module.exports = __webpack_public_path__ + "img/banner.ae674319.jpg";